import { DialogOrDrawer } from '@ui/components/DialogOrDrawer';

import { BondingTradeConfirmButton } from './BondingTradeConfirmButton';
import { BondingTradeForm } from './BondingTradeForm';
import { BondingTradeGasFee } from './BondingTradeGasFee';
import BondingTradeInclFee from './BondingTradeInclFee';

export const DefaultContent = () => {
  return (
    <>
      <DialogOrDrawer.Body pt="20px">
        <BondingTradeForm />
      </DialogOrDrawer.Body>
      <DialogOrDrawer.Footer gap={'4px'} alignItems="stretch">
        <BondingTradeInclFee />
        <BondingTradeGasFee />
        <BondingTradeConfirmButton />
      </DialogOrDrawer.Footer>
    </>
  );
};
